import * as React from "react";
import { twMerge } from "tailwind-merge";

export type DividerProps = {
  orientation?: "horizontal" | "vertical";
  className?: string;
  color?: "divider" | "border";
} & Omit<React.ComponentPropsWithoutRef<"div">, "className">;

export default function Divider({
  orientation = "horizontal",
  className,
  color = "divider",
  ...rest
}: DividerProps) {
  return (
    <div
      role="separator"
      aria-orientation={orientation}
      className={twMerge(
        orientation === "vertical"
          ? "self-stretch border-l"
          : "w-full border-t",
        color === "divider" ? "border-divider" : "border-border",
        className,
      )}
      {...rest}
    />
  );
}
